var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcContent,{class:_vm.$style.settingsApp,attrs:{"appName":"settings"}},[_c(_setup.SettingsNavigation),_vm._v(" "),_c(_setup.SettingsContentWrapper)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }